module.exports = __webpack_public_path__ + "static/media/sobre.c3d7f0b2.jpg";